import React from "react";

const styles = {
  container: {
    width: '100%',
    margin: '0 auto',
    padding: '16px'
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '16px'
  },
  table: {
    width: '100%',
    margin: '0 auto',
    padding: '16px'
  },
  label: {
    fontWeight: '600',
    width: '120px',
    paddingRight: '16px',
    paddingTop: '8px',
    paddingBottom: '8px',
    verticalAlign: 'top'
  },
  value: {
    width: '600px',
    paddingTop: '8px',
    paddingBottom: '8px'
  },

};

const CompanyInformation = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>会社概要</h1>
      <table style={styles.table}>
        <tbody>
          <tr>
            <td style={styles.label}>会社名</td>
            <td style={styles.value}>株式会社 豊栄/HOEI<br/>（かぶしきがいしゃ ほうえい）</td>
          </tr>
          <tr>
            <td style={styles.label}>代表者</td>
            <td style={styles.value}>代表取締役 加藤 伸 （かとうしん）</td>
          </tr>
          <tr>
            <td style={styles.label}>本社</td>
            <td style={styles.value}>
              〒169-0074<br />
              東京都新宿区北新宿四丁目13番10号
              <br />
              (EN) <br />
              Main office <br />
              4-13-10 Kita-Shinjuku <br />
              Shinjuku-ku, Tokyo 169-0074, Japan
            </td>
          </tr>
                    <tr>
            <td style={styles.label}>大阪営業所</td>
            <td style={styles.value}>
              〒530-0041<br />
              大阪府大阪市北区天神橋4丁目6-8<br />
              扇町イトウマンション1階
              <br />
              (EN) <br />
              Osaka Sales Office <br />
              Ogimachi Ito Mansion 1F <br />
              4-6-8 Tenjinbashi, Kita-ku<br />
              Osaka-shi, Osaka 530-0041, Japan
            </td>
          </tr>
          <tr>
            <td style={styles.label}>美濃物流センター</td>
            <td style={styles.value}>
              〒509-5171<br />
              岐阜県土岐市泉北山町1-3<br />
              フリーダイヤル TEL: 0120-05-5472
              <br />
              (EN) <br />
              Mino Logistics Center<br />
              1-3 Izumi-kitayamacho<br />
              Toki-shi, Gifu 509-5171, Japan<br />
              Tel: +81-572-53-3767
            </td>
          </tr>
          <tr>
            <td style={styles.label}>設立</td>
            <td style={styles.value}>1998年6月4日</td>
          </tr>
          <tr>
            <td style={styles.label}>資本金</td>
            <td style={styles.value}>15,000,000円</td>
          </tr>
          <tr>
            <td style={styles.label}>取引銀行</td>
            <td style={styles.value}>
              三菱UFJ銀行・三井住友銀行・みずほ銀行・りそな銀行・十六銀行・東濃信用金庫
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CompanyInformation;